import React from "react";
import { PopUpType } from "../../../home/models/OtherTypes";
import AddPictureListView from "../../../pictures/views/AddPictureListView";
import useNewOneTimeProductVM from "../../viewmodels/NewOneTimeProductVM";

export type NewOneTimeProps = {
    onAction: (refresh: boolean) => void;
}

export default function NewOneTimeView({ onAction }: NewOneTimeProps) {
    const hasLoaded = React.useRef(false);
    const vm = useNewOneTimeProductVM();

    React.useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;
    }, [vm]);

    return <div>
        <AddPictureListView
            popupType={PopUpType.none}
            prefix="files"
            pictures={vm.pictures}
            setPictures={vm.setPictures}
            loading={vm.loading}
            listHash={vm.listHash}
            setListHash={vm.setListHash}
            onValueChange={vm.updatePictureField}
            onCreateList={(prefix) => vm.submit()}
            onClose={() => onAction(false)}
        />
    </div>;
}